exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bookRating{position:relative;display:inline-block;padding-bottom:1px;margin-top:5px;margin-bottom:5px}.bookRating .rateIcon{height:auto;padding-left:1px;padding-right:1px;opacity:.4;filter:grayscale(100%)}.bookRating .rateIcon.active{opacity:1;filter:grayscale(0)}.bookRating .partialIconWrap{display:inline-block;overflow:hidden;position:absolute;top:0}.bookRating.editable:hover{cursor:pointer}.bookRating.editable:hover .rateIcon{opacity:.7;filter:grayscale(40%)}.bookRating.editable:hover .rateIcon.active{opacity:1;filter:grayscale(0)}.bookRating.editable:hover .nestedIconBox:not(:hover) .rateIcon,.bookRating.editable:hover .nestedIconBox:not(:hover) .rateIcon.active{opacity:.4;filter:grayscale(100%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/books/book_rating.scss
// module id = 1384
// module chunks = 0